<!-- @ts-nocheck -->
<template>
  <div class="ISTdateInput">
    <istforminput
      :readonly="readonly"
      :label="label"
      :ref="refinput"
      :id="refinput"
      :modelValue="inputStringDate"
      :name="id"
      :dense="dense"
      :disable="localdisable"
      :disabled="localdisable"
      :error="error || localError"
      :error-message="errorMessage"
      placeholder="dd-mm-åååå"
      clearable
      @update:modelValue="inputChanged"
      @focus="inputFocus"
      @blur="inputBlur"
      @keydown="keyup"
      mask="##-##-####"
      class="ist-datepicker"
      autocomplete="off"
    />
    <q-menu
      :ref="refinputpop"
      v-model="showmenu"
      fit
      no-focus
      :persistent="isPersistent"
      :auto-close="false"
      :separate-close-popup="true"
      anchor="bottom middle"
      self="top middle"
      class="ist-datepicker_popup"
      @before-hide="menuBeforeHide"
      @blur="hideCal"
    >
      <flat-pickr
        :ref="refFlatpickr"
        :modelValue="localFlatpickrDate"
        :config="dateConfig"
        :events="events"
        @on-change="flatpickrValueChanged"
        @on-day-create="onDayCreate"
        v-if="!localdisable"
      ></flat-pickr>
      <div class="multidate-wrapper" v-if="showMultiDates()">
        <q-chip
          v-for="(item, index) in localValue"
          v-bind:key="index"
          :removable="canberemoved()"
          @remove="chipremovedate(item)"
          @click="chipGotoDate(item)"
          color="primary"
          text-color="white"
          icon="date"
          :label="getDateLabel(item)"
        />
      </div>
      <div class="popuptoolbar" v-if="showMultiDates()">
        <q-btn
          v-if="!disable"
          id="datepicker-clear-btn"
          color="secondary"
          style="float: left"
          @click="clearDates"
          >{{ $t("IstDatePicker.clearDates") }}</q-btn
        >
        <q-btn id="datepicker-close-btn" color="primary" style="float: right" @click="hideCal">{{
          $t("IstDatePicker.close")
        }}</q-btn>
      </div>
    </q-menu>
    <q-badge color="accent" floating v-if="showMultiDates()">{{
      getDatesCount() === 1
        ? $t("IstDatePicker.onDateSelected")
        : $t("IstDatePicker.datesChoosen", { datesCount: getDatesCount().toString() })
    }}</q-badge>
  </div>
</template>

<script lang="ts">
// @ts-nocheck
import { Options, Prop, Emit, Watch, Vue } from "vue-property-decorator";
import { ref, inject, nextTick } from "vue";
import istforminput from "./IstFormInput.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Danish } from "flatpickr/dist/l10n/da.js";
import { danishFormat, danishFormatRegex } from "../utils/dateUtils";
import {
  isSameDay,
  isDate,
  format,
  isValid,
  addDays,
  addMonths,
  addYears,
  parseISO,
  min
} from "date-fns";
import filters from "./filters/Filters";

@Options({
  components: {
    flatPickr,
    istforminput
  }
})
export default class App extends Vue {
  @Prop()
  id!: string;
  @Prop({ default: null, type: [Date, String, Array] })
  modelValue!: any;
  @Prop()
  min!: Date;
  @Prop()
  max!: Date;
  @Prop()
  disable!: boolean;
  @Prop()
  label!: string;
  @Prop({ default: false, type: [Boolean, String] })
  multiple!: boolean;
  @Prop({ default: false })
  OnlyAllowEditOnFirstDate!: boolean;
  @Prop({ default: false, type: [Boolean, String] })
  dense!: boolean | string;
  @Prop({ default: false })
  error!: boolean;
  @Prop()
  errorMessage!: string;

  @Emit("onDayCreated")
  emitDayCreated(calendarElement: any) {
    return calendarElement;
  }

  @Emit("onErrorChange")
  emitErrorStatus() {
    return this.localError;
  }

  @Watch("localError")
  onLocalErrorChange() {
    this.emitErrorStatus();
  }

  name = "IstDatepicker";
  inputStringDate = "";
  localValue: Date | Date[] | null = null;
  localdisable = false;
  localError = false;
  refinput = this.id + "input";
  refinputpop = this.id + "inputpop";
  inputref = ref([]);
  refFlatpickr = this.id + "Flatpickr";
  localFlatpickrDate: string | Date | Date[] | null = null;
  isPersistent = false;
  showmenu = false;
  readonly = false;
  events = ["onChange", "onDayCreate"];

  dateConfig = {
    locale: Danish,
    inline: true,
    weekNumbers: true,
    allowInput: false,
    mode: "single",
    clickOpens: false,
    static: true,
    appendTo: this.inputref[0]
  };

  async created() {
    if (this.disable) {
      this.localdisable = this.disable;
    }

    if (this.multiple) {
      this.dateConfig.mode = "multiple";
      this.readonly = true;
    }
    if (Array.isArray(this.modelValue)) {
      this.localFlatpickrDate = [...this.modelValue];
    } else {
      this.onValueChanged(this.modelValue);
    }

    const emitter: any = inject("emitter"); // Inject `emitter`

    emitter.on("myevent", (value) => {
      // *Listen* for event
      console.log("myevent received!", `value: ${value}`);
    });
  }

  mounted() {
    this.inputref = ref([]);
  }

  get Flatpickr() {
    return (this.inputref[this.refFlatpickr] as flatPickr)?.fp;
  }

  // Event for parent
  async onDayCreate(dObj, dStr, fp, calendarElement) {
    this.emitDayCreated(calendarElement);
  }

  // flatpickr @on-change="flatpickrValueChanged"
  flatpickrValueChanged(a: Date[], b: any, c: any) {
    //const emitter: any = inject("emitter"); // Inject `emitter`
    //emitter.emit("myevent", a);
    if (a.length > 0) {
      if (this.multiple === true) {
        if (this.localValue !== null && !Array.isArray(this.localValue)) {
          // flatpickr returns strings !
          const s = (this.localValue as any).split(",");
          this.localValue = [];
          for (let index = 0; index < s.length; index++) {
            const element = s[index];
            this.localValue.push(parseISO(element as string));
          }
        }
        if (!this.localValue) {
          this.localValue = [];
        }
        if (this.OnlyAllowEditOnFirstDate) {
          if (this.localValue.length > 0) {
            const b: Date[] = [...this.localValue]; // eslint hack
            const changedDates = a.filter(
              (newdate) => b.find((olddate) => isSameDay(olddate, newdate)) == undefined
            );
            if (changedDates.length == 1) {
              b[0] = changedDates[0];
              this.localValue = [...b];
              this.$nextTick(() => {
                this.localFlatpickrDate = [...b];
              });
            } else {
              if (this.localValue.length !== a.length) {
                this.localFlatpickrDate = [...this.localValue];
              }
            }
          }
        } else {
          this.localValue.length = a.length;
          for (let index = 0; index < a.length; index++) {
            if (!isSameDay(this.localValue[index], a[index])) {
              this.localValue[index] = a[index];
            }
          }
        }
        this.sendUpdateValueEvent();
        this.writeDatesToInputField(this.localValue);
      } else {
        if (!Array.isArray(this.localValue)) {
          const dato: Date = a[a.length - 1] || new Date();
          if (!this.localValue || !isSameDay(this.localValue, dato)) {
            this.localError = false;
            this.localValue = dato;
            if (isDate(dato)) {
              this.writeDatesToInputField([dato]);
            }
            this.hideCal();
          }
        }
      }
    } else {
      //this.localError = true;
      this.writeDatesToInputField([]);
      if (Array.isArray(this.modelValue)) {
        this.localValue = [];
      } else {
        this.localValue = null;
      }
    }
  }

  clearDates() {
    this.localValue = [];
  }

  writeDatesToInputField(dates: Date[]) {
    if (dates.length > 0) {
      this.inputStringDate = format(min(dates), danishFormat);
    } else {
      this.inputStringDate = "";
    }
  }

  // formInput @change="inputChanged"
  inputChanged(value: string) {
    this.localError = false;
    if (danishFormatRegex.exec(value)) {
      // if the regex is hit, they are 'done' entering a date, and we can tell if its valid or not

      const validatedDate = this.validDanishDate(value);
      if (validatedDate) {
        this.localError = false;
        this.localValue = validatedDate;
      } else {
        this.localError = true;
      }
      if (this.multiple) {
        this.writeDatesToInputField([]);
      }

      this.sendUpdateValueEvent();

      return;
    }
    if (value == null) {
      if (this.multiple) {
        this.localValue = [];
      } else {
        this.localValue = null;
      }
    } else {
      this.localError = true;
    }
    this.sendUpdateValueEvent();
  }

  async keyup(event) {
    let AddValue = 0;
    // keyup
    if (event.keyCode == "38") {
      AddValue = 1;
    }
    // keydown
    if (event.keyCode == "40") {
      AddValue = -1;
    }
    const start = event.target.selectionStart;
    if (AddValue != 0) {
      event.stopPropagation();
      event.preventDefault();
      event.returnValue = false;
      event.cancelBubble = true;
      if (!Array.isArray(this.localValue)) {
        if (!this.localValue) {
          this.localValue = new Date();
        }
        if (event.target.selectionStart < 3) {
          this.localValue = addDays(this.localValue, AddValue);
        } else if (event.target.selectionStart < 6) {
          this.localValue = addMonths(this.localValue, AddValue);
        } else if (event.target.selectionStart < 11) {
          this.localValue = addYears(this.localValue, AddValue);
        }
      } else {
        if (event.target.selectionStart < 11) {
          if (this.localValue.length == 0) {
            this.localValue.push(new Date());
          }
          if (event.target.selectionStart < 3) {
            this.localValue[0] = addDays(this.localValue[0], AddValue);
          } else if (event.target.selectionStart < 6) {
            this.localValue[0] = addMonths(this.localValue[0], AddValue);
          } else if (event.target.selectionStart < 11) {
            this.localValue[0] = addYears(this.localValue[0], AddValue);
          }
          this.onLocalValueChanged(this.localValue, null);
        }
      }
      await nextTick();
      event.target.setSelectionRange(start, start);
      this.chipGotoDate(this.localValue[0]);
      return false;
    }
    return false;
  }

  @Watch("localValue")
  onLocalValueChanged(val: Date | Date[] | null, valOld: Date | Date[] | null = null) {
    if (JSON.stringify(val) !== JSON.stringify(valOld)) {
      this.localFlatpickrDate = val;
      if (val) {
        if (Array.isArray(val)) {
          this.writeDatesToInputField(val);
        } else {
          this.writeDatesToInputField([val]);
        }
      } else {
        this.writeDatesToInputField([]);
      }

      this.sendUpdateValueEvent();
    }
  }
  // form v-model changes
  @Watch("modelValue")
  @Watch("value")
  onValueChanged(val: Date | Date[] | undefined) {
    if (val && Array.isArray(val)) {
      this.writeDatesToInputField(val);
    }
    if (JSON.stringify(val) !== JSON.stringify(this.localValue)) {
      if (val) {
        this.localValue = val;
      } else {
        this.localValue = null;
      }
      this.localError = false;
    }
  }

  @Emit("change")
  @Emit("input")
  @Emit("update:modelValue")
  sendUpdateValueEvent() {
    this.$emit("input", this.localValue);
    this.$emit("change", this.localValue);
    this.$emit("update:modelValue", this.localValue);
    return this.localValue;
  }

  @Watch("disable")
  ondisableChanged(val: boolean | undefined) {
    if (val == true) {
      this.localdisable = val;
      this.hideCal();
      this.showmenu = false;
    } else {
      this.localdisable = false;
    }
  }

  getDatesCount() {
    if (Array.isArray(this.localValue)) {
      return this.localValue.length;
    } else {
      return 0;
    }
  }

  showMultiDates() {
    return this.multiple;
  }

  async hideCal() {
    await nextTick();
    this.showmenu = false;
  }

  inputFocus(event) {
    if (event) {
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }

  inputBlur(event) {
    // todo: check if input has valid date
    const value: string = event.target.value;

    if (value == "" || this.validDanishDate(value)) {
      return;
    }

    this.localError = true;
  }

  menuBeforeHide(e) {
    if (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }

  validDanishDate(value: string): Date | null {
    if (value !== "") {
      const res = danishFormatRegex.exec(value); // res returns a value if the regex found a danish format date, ie. is valid
      if (res) {
        // date is valid isoFormat, checking contents
        const dateArray = value.split("-");
        const year = dateArray[2];
        const month = dateArray[1];
        const day = dateArray[0];
        const date = parseISO(`${year}-${month}-${day}`);
        if (isValid(date)) {
          return date;
        } else {
          this.localError = true;
        }
      } else {
        this.localError = true;
      }
    }
    return null;
  }

  canberemoved() {
    if (this.localdisable || this.OnlyAllowEditOnFirstDate) {
      return false;
    }
    return true;
  }
  chipremovedate(date: Date) {
    if (Array.isArray(this.localValue)) {
      this.localValue = this.localValue.filter((d) => !isSameDay(date, d));
    }
  }
  chipGotoDate(date: Date) {
    if (this.Flatpickr) {
      this.Flatpickr.jumpToDate(date, false);
    }
  }

  getDateLabel(date: Date) {
    return filters.dateShortWithDayName(date);
  }
}
</script>

<style scoped>
.hidden-picker {
  visibility: hidden;
  width: 0px;
  height: 0px;
  position: absolute;
}
.flatpickr-wrapper input {
  display: none;
}

@media screen and (max-width: 544px) {
  .ISTdateInput {
    position: relative;
    min-width: -webkit-fill-available;
  }
}

@media screen and (min-width: 545px) {
  .ISTdateInput {
    position: relative;
  }
}

.ISTdateInput :deep(input::-webkit-inner-spin-button),
.ISTdateInput :deep(input::-webkit-calendar-picker-indicator) {
  display: none;
  -webkit-appearance: none;
}

.multidate-wrapper {
  width: 200px;
  float: right;
  padding: 0 16px;
  overflow: auto;
  height: 300px;
}
.popuptoolbar {
  width: 100%;
  height: 40px;
  background-color: #eee;
  padding: 3px;
  display: table;
}
</style>
<style>
.grey-background {
  background-color: #eee;
  border-radius: 7px;
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  z-index: -1;
  left: 0;
}

.event {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 150px;
  bottom: 3px;
  left: calc(50% - 1.5px);
  content: " ";
  display: block;
  background: #3d8eb9;
}

.event.trianglebottomright {
  background: none;
  width: 0;
  height: 0;
  border-radius: 0;
  border-bottom: 6px solid #f64747;
  border-left: 6px solid transparent;
}

.event.triangletopleft {
  background: none;
  width: 0;
  height: 0;
  border-radius: 0;
  border-top: 6px solid olivedrab;
  border-right: 6px solid transparent;
}
.event.circle {
  width: 6px;
  height: 6px;
  background: darkorange;
  border-radius: 50%;
}
.event.square {
  width: 6px;
  height: 6px;
  background: red;
}
.ist-datepicker_popup .flatpickr-calendar:before,
.ist-datepicker_popup .flatpickr-calendar:after {
  content: none;
}
.ist-datepicker_popup .flatpickr-calendar.inline {
  top: 0;
}
</style>
